export default {
  primaryLight: '#f4f6f5',
  accent: '#6cc',
  anchor: '#6cc',
  resultPositive: '#6cc',
  primary: '#3CB7B7',
  error: '#fd584e',
  neutralDark: '#5f6a7d',
  black: '#5f6a7d',
  secondary: '#f4f6f5',
  neutralLight: '#f4f6f5',
  resultInactive: '#CACFD2',
  neutralMedium: '#9AA6B6',
  green: '#4DE52E',
  success: '#6AA84F',
  textColor: '#61718A',
  workflowBg: '#FFFFFF',
  workflowHeaderBg: '#f4f6f5',
};
